import React from 'react';

import type { Nullable } from '@clearverify/types';

export interface SearchContextValue {
  setSearchValue: (value: Nullable<string>) => void;
  searchValue: Nullable<string>;
  setSearchCategory: (category: Nullable<string>) => void;
  searchCategory: Nullable<string>;
}

export const SearchContext = React.createContext<SearchContextValue>({} as SearchContextValue);
